<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      username: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
    webhookUrl() {
      return `${window.location.origin}/webhooks/falesempre`;
    },
  },
  validations: {
    inboxName: { required },
    username: { required },
    password: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;
      try {
        const smsChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'sms',
            phone_number: this.username,
            provider: 'falesempre',
            provider_config: {
              username: this.username,
              password: this.password,
            },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: smsChannel.id },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.SMS.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.INBOX_NAME.PLACEHOLDER')
          "
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.username.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.USERNAME.LABEL') }}
        <input
          v-model="username"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.USERNAME.PLACEHOLDER')
          "
          @blur="v$.username.$touch"
        />
        <span v-if="v$.username.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.USERNAME.ERROR') }}
        </span>
      </label>
    </div>
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.password.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.PASSWORD.LABEL') }}
        <input
          v-model="password"
          type="password"
          :placeholder="
            $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.PASSWORD.PLACEHOLDER')
          "
          @blur="v$.password.$touch"
        />
        <span v-if="v$.password.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.PASSWORD.ERROR') }}
        </span>
      </label>
    </div>
    <div class="flex-shrink-0 flex-grow-0 mt-2">
      <p class="text-sm text-slate-500">
        {{ $t('INBOX_MGMT.ADD.SMS.FALESEMPRE.WEBHOOK_HINT.LABEL') }}
        <code class="text-xs bg-slate-100 px-1 rounded">{{ webhookUrl }}</code>
      </p>
    </div>
    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.SMS.FALESEMPRE.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
